import { defineFcm } from '../shared/factory';

export const FCM_ALLOW_FETCH_SIGNATURE_COUNT_FOR_COUNTRY = defineFcm('allow_fetch_signature_count_for_country')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-middle-end',
		context: 'Signature Counts',
		description:
			'If true, middle-end fetches the signature count for country/state in signatureCountsByCountryOrStateCode.',
		import: false,
	});
